import { render, staticRenderFns } from "./dealSetting.vue?vue&type=template&id=39ad813c&scoped=true&"
import script from "./dealSetting.vue?vue&type=script&lang=js&"
export * from "./dealSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ad813c",
  null
  
)

component.options.__file = "dealSetting.vue"
export default component.exports